"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _Icon = _interopRequireDefault(require("../ImagesAndIcons/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const LabelWrapper = _styledComponents.default.label.withConfig({
  displayName: "Label__LabelWrapper",
  componentId: "design-system__sc-1u603j5-0"
})(["font-family:", ";font-size:", ";color:", ";display:block;line-height:100%;padding:1.6rem 0px 0.5rem;.info{display:inline-block;vertical-align:middle;margin-left:8px;svg{path{fill:", ";}}}.ReactTooltip{max-width:400px;font-family:", ";}.optional{font-family:", ";color:", ";font-size:", ";display:inline-block;margin-left:3rem;}&.required:after{content:'*';display:inline-block;color:", ";margin-left:", ";}"], _BaseTheme.default.type.family.system, _BaseTheme.default.type.size.large, _BaseTheme.default.colors.gray, _BaseTheme.default.colors.lightgray, _BaseTheme.default.type.family.content, _BaseTheme.default.type.family.content, _BaseTheme.default.colors.lightgray, _BaseTheme.default.type.size.small, _BaseTheme.default.colors.red, _BaseTheme.default.distance.small);

const Label = _ref => {
  let {
    className,
    children,
    info,
    optional,
    htmlFor,
    required
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(LabelWrapper, {
    className: "".concat(className, " ").concat(required ? 'required' : ''),
    htmlFor: htmlFor
  }, children, !!info && /*#__PURE__*/_react.default.createElement("div", {
    className: "info",
    "data-tip": info
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "16",
    type: "info"
  }), /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    className: "ReactTooltip",
    place: "right",
    type: "light",
    effect: "solid",
    border: true,
    borderColor: "#B4B4B4"
  })), !!optional && /*#__PURE__*/_react.default.createElement("span", {
    className: "optional"
  }, "Optional"));
};

Label.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  info: _propTypes.default.string,
  optional: _propTypes.default.bool,
  htmlFor: _propTypes.default.string,
  required: _propTypes.default.bool
};
Label.defaultProps = {
  className: '',
  info: '',
  optional: false,
  htmlFor: '',
  required: false
};
var _default = Label;
exports.default = _default;